import React from "react";
import { Check, TriangleAlert, Clock3, Clock, Hourglass } from "lucide-react";
import { TID } from "@/lib/testIds";
import { SectionTitle } from "@/components/FinancialCharts";

export default function AdvantagesRisks({ data }) {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="card-tactical p-5 sm:p-6" data-testid={TID.advantageList}>
        <SectionTitle title="AI 優勢分析" subtitle="Advantages" />
        <ul className="mt-3 space-y-3 stagger">
          {(data.advantages || []).map((a) => (
            <li key={a.title} className="flex items-start gap-3">
              <div className="mt-0.5 w-6 h-6 rounded-md bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center shrink-0">
                <Check className="w-3.5 h-3.5 text-emerald-400" strokeWidth={2.4} />
              </div>
              <div>
                <div className="text-sm font-semibold text-zinc-100">{a.title}</div>
                <div className="text-xs sm:text-sm text-zinc-400 leading-relaxed mt-0.5">
                  {a.detail}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="card-tactical p-5 sm:p-6" data-testid={TID.riskList}>
        <SectionTitle title="AI 風險分析" subtitle="Risks · 短 / 中 / 長期" />
        <div className="space-y-4 mt-3">
          <RiskBucket icon={Clock3} label="短期風險" tone="red" items={data.risks?.short} />
          <RiskBucket icon={Clock} label="中期風險" tone="amber" items={data.risks?.mid} />
          <RiskBucket icon={Hourglass} label="長期風險" tone="orange" items={data.risks?.long} />
        </div>
      </div>
    </section>
  );
}

function RiskBucket({ icon: Icon, label, items = [], tone = "red" }) {
  const toneMap = {
    red: "bg-red-500/10 border-red-500/20 text-red-400",
    amber: "bg-amber-500/10 border-amber-500/20 text-amber-400",
    orange: "bg-orange-500/10 border-orange-500/20 text-orange-400",
  };
  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <div className={`w-6 h-6 rounded-md flex items-center justify-center border ${toneMap[tone]}`}>
          <Icon className="w-3.5 h-3.5" strokeWidth={1.8} />
        </div>
        <span className="text-xs uppercase tracking-widest font-semibold text-zinc-300">
          {label}
        </span>
        <span className="text-[10px] font-mono text-zinc-500 ml-1">
          {items.length} items
        </span>
      </div>
      <ul className="space-y-2 pl-1">
        {items.map((r) => (
          <li key={r.title} className="flex items-start gap-2">
            <TriangleAlert className={`w-3.5 h-3.5 mt-1 shrink-0 ${toneMap[tone].split(" ")[2]}`} strokeWidth={1.8} />
            <div>
              <div className="text-sm text-zinc-100 font-medium">{r.title}</div>
              <div className="text-xs text-zinc-500 leading-relaxed">{r.impact}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
